import { colors } from "@/styles/colors"
import ColorUtil from "@/utils/ColorUtil"

import { makeStyles } from "@material-ui/core"

const useStyles = makeStyles({
	filterInput: {
		...ColorUtil.getBackgroundAndContrastColor(colors.gray[0]),
		"& fieldset": {
			borderRadius: 3
		}
	}
})

export default useStyles
